import React from 'react';
import cx from 'classnames';

type BgColor =
  | 'dark-orange'
  | 'grey'
  | 'grey-darker'
  | 'white'
  | 'grey-light'
  | 'mint'
  | 'mint-light'
  | 'purple'
  | 'light-attention'
  | 'dark'
  | 'purple-dark';

type Color =
  | 'attention'
  | 'orange'
  | 'brand'
  | 'mint'
  | 'danger'
  | 'warning'
  | 'info'
  | 'yellow'
  | 'purple'
  | 'purple-dark'
  | 'base-dark'
  | 'base-light'
  | 'white'
  | 'black'
  | 'white-shadow';

interface Props {
  bg?: BgColor;
  color?: Color;
  className?: string;
}

const wrapperCx = 'banner-cta w-100 flexbox flex-align-center';

const Banner: React.FC<Props> = ({
  children,
  bg,
  color,
  className,
  ...rest
}) => (
  <div
    className={cx(wrapperCx, {
      [`back-${bg}`]: Boolean(bg),
      [`color-${color}`]: Boolean(color),
    })}
  >
    <div className={cx('w-100', className)} {...rest}>
      {children}
    </div>
  </div>
);

export { Banner };
